import { Box, BoxProps, useMediaQuery } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import About from '../../../components/Company/About';
import SidebarLayout from '../../../layouts/SidebarLayout';
import { useThemeContext } from '../../../theme/ThemeContextProvider';
import CompanySidebar from '../../../components/Company/CompanySidebar/CompanySidebar';
import CompanyInfo from '../../company/CompanySettings/CompanyInfo';
import { Photos, Videos } from '../../../components/Media';
import VerificationNotifyModal from '../ProfilePage/components/modals/VerificationNotifyModal';
import { useSelector } from 'react-redux';
import { selectAuthData } from '../../../store/selectors/authSelector';

const CompanyPage = () => {
  const { theme } = useThemeContext();
  const mobileView = useMediaQuery(theme.breakpoints.down('lg'));
  const location = useLocation();
  const navigate = useNavigate();
  const authData = useSelector(selectAuthData);

  const mobileProps: BoxProps = mobileView
    ? {
        flexDirection: 'column',
        marginTop: { xs: '-20px', md: '-24px' },
      }
    : {};

  return (
    <>
      <VerificationNotifyModal
        isOpen={location?.state?.showUnverifiedUserModal}
        role={authData?.user?.role}
        onClose={() => {
          navigate(location.pathname, {
            state: { showUnverifiedUserModal: false },
          });
        }}
      />
      <SidebarLayout sidebar={<CompanySidebar />} {...mobileProps}>
        <Box display="flex" flexDirection="column" gap="22px" flexGrow="1">
          <Box id="company-info">
            <CompanyInfo />
          </Box>
          <Box id="about">
            <About />
          </Box>
          <Box id="photos">
            <Photos />
          </Box>
          <Box id="videos">
            <Videos />
          </Box>
        </Box>
      </SidebarLayout>
    </>
  );
};

export default CompanyPage;
